import { take, call, put, race } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import {
  LOGIN,
  LOGIN_LOADING,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  AUTH_WITH_TOKEN_LOADING,
  AUTH_WITH_TOKEN_FAILURE,
  AUTH_WITH_TOKEN_SUCCESS,
  REFRESH_TOKEN_LOADING,
  REFRESH_TOKEN_FAILURE,
  REFRESH_TOKEN_SUCCESS,
  LOGOUT,
  logout,
} from '../actions'

const auth = ({
  /**
   * Function to authenticate with credentials
   * (credentials) => Promise({ access_token, refresh_token })
   */
  login,
  /**
   * Function to get user data from token
   * (access_token) => Promise(user)
   */
  me,
  /**
   * Function to refresh token, when not provided token will no be refreshed
   * (refresh_token) => Promise({ access_token, refresh_token })
   */
  refreshToken,
  /**
   * Milleseconds tick to refresh token
   */
  refreshTokenTick = 60 * 5 * 1000, // 5 minutes
}) => {
  /**
   * Store, Get and Remove token from local storage.
   */
  const STORAGE_KEY = 'swapick-web-access-token'
  const storeToken = token => localStorage.setItem(STORAGE_KEY, token)
  const getToken = token => localStorage.getItem(STORAGE_KEY, token)
  const removeToken = () => localStorage.removeItem(STORAGE_KEY)

  /**
   * Pull login action and then try to authenticate user with given
   * credentials, if ok store token.
   */
  function* watchLogin() {
    const { payload } = yield take(LOGIN)
    const { credentials } = payload
    yield put({ type: LOGIN_LOADING })
    try {
      const { access_token, refresh_token } = yield call(login, credentials)
      // Using access token to get user info
      const user = yield call(me, access_token)
      // The relevant is the refresh token
      try {
        yield call(storeToken, access_token)
      } catch (error) {
        console.error('Failed to store access token to local storage', error)
      }
      // yield call(storeToken, refresh_token);
      // Notify redux store login is ok!
      yield put({
        type: LOGIN_SUCCESS,
        payload: {
          user,
          access_token,
          refresh_token,
        },
      })
    } catch (error) {
      yield put({
        type: LOGIN_FAILURE,
        error: !error ? null : error.message ? error.message : error,
      })
    }
  }

  /**
   * Pull logout action and then remove token from storage.
   */
  function* watchLogout() {
    yield take(LOGOUT)
    yield call(removeToken)
  }

  /**
   * When token is in local storage take it, refresh it (if neeeded),
   * get user data and authenticate in redux store.
   */
  function* authenticateWithStorageToken() {
    let oldAccessToken = yield call(getToken)
    if (oldAccessToken) {
      // console.info(`Got a token in local storage [${oldRefreshToken}], refresh them.`);
      yield put({ type: AUTH_WITH_TOKEN_LOADING })
      try {
        // Refresh token from storage before me
        // const { access_token, refresh_token } = yield call(refreshToken, oldRefreshToken);
        // console.info(`Token refreshed [${refresh_token}], get user info by token`);
        // Get the user data using access token
        const user = yield call(me, oldAccessToken)
        // Store the new refresh token
        // yield call(storeToken, refresh_token);
        // console.info(`Got the user info [${JSON.stringify(user)}] by refreshed token in local storage.`);
        // Authenticate user in state
        // FIXME: Temporaney workaround...
        const access_token = oldAccessToken
        yield put({
          type: AUTH_WITH_TOKEN_SUCCESS,
          payload: {
            user,
            access_token,
            // refresh_token,
          },
        })
        return access_token
        // return refresh_token;
      } catch (error) {
        // console.error('Failed to authenticate with token in local storage.');
        yield put({
          type: AUTH_WITH_TOKEN_FAILURE,
          error: error.message ? error.message : error,
        })
        // The token was wrong...
        yield call(removeToken)
      }
    }
  }

  /**
   * Refresh token on N milleseconds, set new token in state and in local storage
   * when failed for auth problem dispatch logout.
   */
  function* watchRefreshToken(tokenToRefresh) {
    let token = tokenToRefresh
    while (true) {
      yield call(delay, refreshTokenTick)
      yield put({ type: REFRESH_TOKEN_LOADING })
      try {
        console.info(`Time to refresh token [${token}].`)
        const { access_token, refresh_token } = yield call(refreshToken, token)
        // Assign new token...
        token = refresh_token
        yield call(storeToken, token)
        console.info(`Token refreshed [${token}].`)
        yield put({
          type: REFRESH_TOKEN_SUCCESS,
          payload: { access_token, refresh_token },
        })
      } catch (error) {
        console.error('Fail to refresh token.')
        yield put({
          type: REFRESH_TOKEN_FAILURE,
          error: error.message ? error.message : error,
        })
        if (error.status === 401 || error.status === 403) {
          yield put(logout())
        }
      }
    }
  }

  /**
   * Race between refresh and logout.
   */
  function* watchRefreshTokenAndLogout(token) {
    if (typeof refreshToken === 'function') {
      yield race({
        logout: watchLogout(),
        refresh: watchRefreshToken(token),
      })
    } else {
      yield watchLogout()
    }
  }

  /**
   * le Auth Flow
   */
  return function* authFlow() {
    // auth using local storage token
    let token = yield authenticateWithStorageToken()
    if (token) {
      yield watchRefreshTokenAndLogout(token)
    }

    // auth using login form
    while (true) {
      token = yield watchLogin()
      if (token) {
        yield watchRefreshTokenAndLogout(token)
      }
    }
  }
}

export default auth



// WEBPACK FOOTER //
// ./src/saga/auth.js